import React from 'react'
import { toast } from 'react-toastify'

const normalizeToastText = (value) => {
    if (value == null) {
        return "";
    }

    if (React.isValidElement(value)) {
        return value;
    }

    if (typeof value === "object") {
        if (value.message) {
            return normalizeToastText(value.message);
        }

        try {
            return JSON.stringify(value);
        } catch (error) {
            return String(value);
        }
    }

    return String(value);
}

class Toastify {
    success(title, desc) {
        return toast.success(<Success title={normalizeToastText(title)} desc={normalizeToastText(desc)} />, {
            icon: ({ theme, type }) => <img src="/assets/icons/success.svg" />
        })
    }
    
    

    warning(title, desc) {
        return toast.warning(<Warning title={normalizeToastText(title)} desc={normalizeToastText(desc)} />, {
            icon: ({ theme, type }) => <img src="/assets/icons/warning.svg" />
        })
    }

    error(title, desc) {
        return toast.error(<Error title={normalizeToastText(title)} desc={normalizeToastText(desc)} />, {
            icon: ({ theme, type }) => <img src="/assets/icons/error.svg" />
        })
    }
    info(title, desc) {
        return toast.info(<Info title={normalizeToastText(title)} desc={normalizeToastText(desc)} />, {
            icon: ({ theme, type }) => <img src="/assets/icons/info.svg" />
        })
    }
}

const Success = ({ title = "", desc = "" }) => {
    return (
        <div className='Toastify__toast--success' style={{ marginLeft: 20,width:"100%",display: "flex",
            alignItems: "center", }}>
            <h4 style={{ color: "#fff", fontSize: "14px", padding: 0, margin: 0, fontFamily: "Poppins", }}>{title}</h4>
            <p style={{ color: "#C8C5C5", fontSize: "12px", padding: 0, margin: 0, fontFamily: "Poppins" }}>{desc}</p>
        </div>
    )
}

const Warning = ({ title = "", desc = "" }) => {
    return (
        <div style={{ marginLeft: 20 ,width:"100%" }}>
            <h4 style={{ color: "#fff", fontSize: "14px", padding: 0, margin: 0, fontFamily: "Poppins" }}>{title}</h4>
            <p style={{ color: "#C8C5C5", fontSize: "12px", padding: 0, margin: 0, fontFamily: "Poppins" }}>{desc}</p>
        </div>
    )
}

const Error = ({ title = "", desc = "" }) => {
    return (
        <div style={{ marginLeft: 20  ,width:"100%"}}>
            <h4 style={{ color: "#fff", fontSize: "14px", padding: 0, margin: 0, fontFamily: "Poppins" }}>{title}</h4>
            <p style={{ color: "#C8C5C5", fontSize: "12px", padding: 0, margin: 0, fontFamily: "Poppins" }}>{desc}</p>
        </div>
    )
}
const Info = ({ title = "", desc = "" }) => {
    return (
        <div style={{ marginLeft: 20,width:"100%" }}>
            <h4 style={{ color: "#fff", fontSize: "14px", padding: 0, margin: 0, fontFamily: "Poppins" }}>{title}</h4>
            <p style={{ color: "#C8C5C5", fontSize: "12px", padding: 0, margin: 0, fontFamily: "Poppins" }}>{desc}</p>
        </div>
    )
}

export default new Toastify();
